import JSXComponent from "../../../dist/jsx-render/JSXComponent";
import dom from "../../../dist/jsx-render/dom";
import { GridViewSelectPopupProps } from "./GridViewSelectPopup";
import { IGridFilterCollection } from "../../Common/Grid/Filters/mso.grid.filters.contracts";
import { ButtonComponent } from "../../Components/ButtonComponent";
import { ConditionComponent, ConditionComponentProps } from "../../Components/Conditions/ConditionComponent";
import { Condition } from "../../Pages/Measure/VisibilityDependency/Condition";
import { ITreeField } from "./ITreeField";
import { GridViewConditionContext } from "../../Components/Conditions/ConditionContext/GridViewConditionContext";

export type GridViewSelectFilterProps = {
    model: Condition[];
    availableFields: ITreeField;
    decimalChar?: number;
}

export class GridViewSelectFilter extends JSXComponent {
    props: GridViewSelectFilterProps;
    constructor(props: GridViewSelectFilterProps) { super(props); }

    private conditionComponents: ConditionComponent[] = [];

    addFilter = (): void => {
        if (this.conditionComponents && this.conditionComponents.length > 0) {
            // Set default link to AND on last Condition if it wasn't set already.
            this.conditionComponents[this.conditionComponents.length - 1].setDefaultNextLink();
        }

        let newCondition: Condition = new Condition();
        this.props.model.push(newCondition);
        let context = new GridViewConditionContext(newCondition, this.props.availableFields);

        let filtersElement = this.element.querySelector(".filters") as HTMLDivElement;

        let conditionComponentProps: ConditionComponentProps = {
            decimalChar: this.props.decimalChar,
            model: newCondition,
            context: context,
            onDelete: this.deleteFilter,
            showOnlyDatePicker: true
        }
        let conditionComponent = new ConditionComponent(conditionComponentProps);
        this.conditionComponents.push(conditionComponent);

        filtersElement.appendChild(conditionComponent.render());
    }

    deleteFilter = (model: Condition): void => {
        this.props.model.splice(this.props.model.indexOf(model), 1);
    }

    element: HTMLElement;
    getElement = () => {
        this.element = <div className="gridview-select-filter">
            <div className="filters">
                {this.props.model.map(f => {
                    let context = new GridViewConditionContext(f, this.props.availableFields);

                    let conditionComponentProps: ConditionComponentProps = {
                        decimalChar: this.props.decimalChar,
                        model: f,
                        context: context,
                        onDelete: this.deleteFilter,
                        showOnlyDatePicker: true
                    }
                    let conditionComponent = new ConditionComponent(conditionComponentProps);
                    this.conditionComponents.push(conditionComponent);

                    return conditionComponent.render();
                })}
            </div>

            <div className="add-filters">
                <ButtonComponent text={Resources.Common.addFilter} altText={Resources.Common.addFilter} action={this.addFilter} />
            </div>
        </div>

    }

    render() {
        if (!this.props.model) {
            this.props.model = [];
            this.props.model.push(new Condition());
        }
        else if (this.props.model.length === 0) {
            this.props.model.push(new Condition());
        }

        this.getElement();

        return this.element;
    }
}